import { SuitabilityPanelComponent } from './suitability-panel.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TrLoadingOverlayModule, SvgIconModule, TrInputsModule, AlertMessageModule } from '@toro/common/shared/components';

@NgModule({
    declarations: [
        SuitabilityPanelComponent,
    ],
    imports: [
        CommonModule,
        SvgIconModule,
        TrInputsModule,
        TrLoadingOverlayModule,
        AlertMessageModule,
    ],
    entryComponents: [
        SuitabilityPanelComponent,
    ],
})

export class SuitabilityPanelModule { }